import { createContext, useContext } from "react";

import type { RightPaneItem } from "./RightPaneState";

const RightPaneChainContext = createContext<Array<RightPaneItem>>([]);

export const RightPaneChainContextProvider = RightPaneChainContext.Provider;

export const useRightPaneChain = (): Array<RightPaneItem> => useContext(RightPaneChainContext);
